export default __webpack_public_path__ + "static/text-bottom-green-c7b7f302c5eb0f369472d6477cd22506.svg";